{
  "dss": {
    "button": {
      "back": "Atgal",
      "cancel": "Atšaukti",
      "close": "Uždaryti",
      "confirmDelete": "Taip, ištrinti",
      "continue": "Tęsti",
      "logout": "Atsijungti",
      "passwordReset": "Slaptažodžio atstatymas",
      "save": "Išsaugoti",
      "verify": "Patvirtinti"
    },
    "error": {
      "403": "Neturite prieigos prie šio puslapio.",
      "404": "Šio puslapio nėra.",
      "generic": "Įvyko klaida. Bandykite dar kartą vėliau.",
      "throttling": "Per daug bandymų. Operacija laikinai užblokuota.",
      "title": "Klaida",
      "title403": "Prieiga uždrausta",
      "title404": "Nerasta"
    },
    "footer": {
      "imprint": "Rekvizitai",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Privatumo politika",
      "terms": "Taisyklės ir sąlygos"
    },
    "label": {
      "CRMAccountNumber": "CRM paskyros numeris",
      "contact": "Kontaktai",
      "email": "El. paštas",
      "faq": "DUK",
      "female": "Ponia",
      "firstname": "Vardas",
      "help": "Pagalba",
      "language": "Kalba",
      "lastname": "Pavardė",
      "male": "Ponias",
      "needHelp": "Reikia pagalbos?",
      "newPassword": "Naujas slaptažodis",
      "newPassword2": "Patvirtinti naują slaptažodį",
      "oldPassword": "Dabartinis slaptažodis",
      "organization": "Organizacija",
      "password": "Slaptažodis",
      "required": "privaloma",
      "salutation": "Kreipinys",
      "select": "Pasirinkite"
    },
    "lang": {
      "de": "Vokiečių"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Patvirtinti registraciją",
        "wait": "Palaukite, kol bus baigtas paskyros patvirtinimas."
      },
      "otp": {
        "btnResend": "Siųsti patvirtinimo kodą iš naujo",
        "msg": {
          "invalidOTP": "Įvestas vienkartinis slaptažodis neteisingas.",
          "resendFail": "Nepavyko išsiųsti kodo. Bandykite vėliau dar kartą."
        },
        "spamDetail": "Patikrinkite gautuosius ir šlamšto aplanką dėl laiško iš STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Negavote el. laiško?",
        "subtitle": "Norėdami tęsti, turite patvirtinti savo el. pašto adresą.",
        "title": "Patvirtinkite savo naudotojo paskyrą",
        "txtVerifyMail": "Įveskite naują patvirtinimo kodą, kurį išsiuntėme į jūsų el. pašto adresą {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Nėra ką atnaujinti.",
          "updateError": "Nepavyko atnaujinti asmens duomenų.",
          "updated": "Asmens duomenys atnaujinti.",
          "userLoadErr": "Įkeliant naudotojo duomenis įvyko klaida. Bandykite vėliau."
        },
        "secOrganization": "Organizacija",
        "secPersonal": "Asmeniniai",
        "secSettings": "Pageidaujami nustatymai",
        "title": "Asmeninė informacija"
      },
      "postPwSet": {
        "info": "Dabar galite naudoti naują slaptažodį.",
        "link_name": "Tęsti į savitarną",
        "link_url": "/user/ui/",
        "title": "Jūsų slaptažodis buvo pakeistas"
      },
      "resetPW": {
        "title": "Atstatykite savo slaptažodį"
      },
      "security": {
        "2fa": {
          "availableMethods": "Galimi 2FA metodai:",
          "info": "Dvikopis autentifikavimas (2FA) – tai saugumo funkcija, kuri suteikia papildomą apsaugos sluoksnį jūsų paskyrai. Prisijungdami turite naudoti du metodus, o ne tik naudotojo vardą ir slaptažodį.",
          "method": {
            "email": "El. paštas",
            "emailDesc": "Gaukite vienkartinius kodus el. paštu, kad užbaigtumėte autentifikavimo užklausas.",
            "oath": {
              "add": {
                "button": "Registruoti autentifikavimo programėlę"
              }
            }
          }
        },
        "authenticator": "Autentifikavimo programėlė",
        "infoFederatedAccount": "Šią paskyrą valdo jūsų organizacijos tapatybės teikėjas, todėl slaptažodžio čia pakeisti negalima. Norėdami pakeisti slaptažodį, prisijunkite per savo organizacijos prisijungimo puslapį arba kreipkitės į IT administratorių.",
        "lastUse": "Paskutinį kartą naudota: {0}.",
        "msg": {
          "invalidPassword": "Neteisingas dabartinis slaptažodis.",
          "passwordAlreadyUsed": "Negalima pakartotinai naudoti paskutinių 5 slaptažodžių.",
          "pwUpdateError": "Bandant pakeisti slaptažodį įvyko klaida.",
          "pwUpdated": "Slaptažodis pakeistas."
        },
        "noDevice": "Nesukonfigūruota",
        "oathAdd": {
          "appInfo": "Norėdami palengvinti prisijungimo prie STIHL procesą, galite naudoti autentifikavimo programėles, tokias kaip {0}, {1}, {2} ir kt., kad sugeneruotumėte vienkartinius slaptažodžius, naudojamus kaip antrasis faktorius prisijungimo metu.<br/>Jei pametėte arba pamiršote savo mobilųjį įrenginį, visada galite naudoti el. paštu atsiųstą 2FA kodą.<br/><br/>Vadovaukitės toliau pateiktomis instrukcijomis, kad sukonfigūruotumėte savo autentifikavimo įrenginį.",
          "badCode": "Neteisingas kodas, bandykite dar kartą.",
          "error": "Bandant registruoti autentifikavimo įrenginį, įvyko klaida.",
          "headScan": "1. Nuskaitykite QR kodą naudodami autentifikavimo programėlę",
          "headVerify": "2. Patvirtinkite kodą",
          "infoKey": "nustatymo raktas",
          "infoKeyTitle": "Jūsų dvikopio autentifikavimo paslaptis",
          "infoScanBottom": "Negalite nuskaityti? Galite naudoti {0}, kad rankiniu būdu sukonfigūruotumėte autentifikavimo programėlę.",
          "infoVerify": "Įveskite kodą, kurį sugeneravo jūsų autentifikavimo programėlė.",
          "success": "Jūsų autentifikavimo įrenginys užregistruotas. Dabar galite juo prisijungti.",
          "title": "Užregistruokite savo dvikopio autentifikavimo įrenginį"
        },
        "oathDelete": {
          "error": "Bandant ištrinti autentifikavimo įrenginį, įvyko klaida.",
          "success": "Autentifikavimo įrenginys ištrintas."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey – tai kriptografinių raktų poros (viešasis ir privatus raktas), kurias saugo jūsų valdomas autentifikatorius. Autentifikatorius gali įrodyti, kad naudotojas yra prisijungęs ir turi teisę naudoti passkey. Autentifikatoriai įrodo teises naudodami PIN, kodą, biometrinius duomenis arba įrenginio slaptažodį, priklausomai nuo jų galimybių ir konfigūracijos. Autentifikatoriai gali būti įvairių formų: iPhone ar Android įrenginys, Windows Hello, FIDO2 aparatinis saugos raktas arba slaptažodžių tvarkyklė.",
            "info2": "Kai naudojate passkey prisijungdami prie STIHL, jūsų autentifikatorius naudoja viešojo rakto kriptografiją, kad įrodytų jūsų tapatybę STIHL, niekada nesiųsdamas paties passkey. Passkey yra susieti su svetainės domenu, pvz., stihl-sso.com, ir reikalauja saugaus ryšio, o tai reiškia, kad naršyklė atsisakys autentifikuotis įklastotame sukčiavimo puslapyje. Šios savybės daro passkey labai atsparius sukčiavimui ir daug sunkiau atakuojamus nei SMS ar TOTP 2FA, kuriuos galima apgauti.",
            "info3": "Debesijos pagrindu veikiančios passkey paslaugos leidžia sinchronizuoti raktus tarp įrenginių (pvz., Apple įrenginių, Android įrenginių ar slaptažodžių tvarkyklių), kad jie būtų prieinami daugiau vietose ir mažiau prarandami. Sukonfigūravus sinchronizuotą passkey viename įrenginyje, jis tampa prieinamas keliuose įrenginiuose, naudojančiuose tą pačią paslaugą. Pavyzdžiui, jei registruojate passkey naudodami savo iCloud paskyrą per „MacBook“ „Touch ID“, vėliau galite naudoti šį passkey naudodami veidą, piršto atspaudą, PIN arba įrenginio slaptažodį keliuose įrenginiuose, susietuose su ta pačia iCloud paskyra.",
            "title": "Apie passkey"
          },
          "add": {
            "button": "Pridėti naują Passkey",
            "error": "Bandant pridėti naują passkey, įvyko klaida.",
            "success": "Naujas passkey pridėtas."
          },
          "delete": {
            "button": "Ištrinti Passkey",
            "error": "Bandant ištrinti šį passkey, įvyko klaida.",
            "success": "Passkey ištrintas."
          },
          "edit": {
            "error": "Bandant išsaugoti passkey pavadinimą, įvyko klaida.",
            "name": "Passkey pavadinimas",
            "success": "Passkey pavadinimas atnaujintas.",
            "title": "Suteikite savo passkey pavadinimą, kad atskirtumėte jį nuo kitų"
          },
          "info": "Passkey – tai paprasta ir saugi alternatyva slaptažodžiams, patvirtinanti jūsų tapatybę naudojant prisilietimą, veido atpažinimą, įrenginio slaptažodį arba PIN.",
          "none": "Nėra sukonfigūruoto Passkey.",
          "reallyDelete": "Ar tikrai norite ištrinti Passkey?",
          "registeredPasskeys": "Jūsų užregistruoti Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Ar tikrai norite ištrinti autentifikavimo įrenginį?",
        "secMFA": "Dvikopis autentifikavimas",
        "secPwdChange": "Pakeisti slaptažodį",
        "title": "Saugumas"
      },
      "setPW": {
        "acceptTC": "Patvirtinkite mūsų {terms} ir perskaitykite mūsų {privacy}.",
        "killSSO": "Anuliuoti visas aktyvias sesijas",
        "msg": {
          "tokenExpired": "Slaptažodžio nuorodos arba kodo galiojimas baigėsi. Norėdami iš naujo nustatyti slaptažodį, sekite nuorodą: {link}."
        },
        "privacy": "Duomenų privatumo politika",
        "terms": "Taisyklės ir sąlygos",
        "title": "Įveskite naują slaptažodį"
      }
    },
    "validations": {
      "hasDigit": "Turi būti skaitmuo(-ys)",
      "hasLowercase": "Turi būti mažųjų raidžių",
      "hasSpecial": "Turi būti specialiųjų simbolių: {chars}",
      "hasUppercase": "Turi būti didžiųjų raidžių",
      "invalidCharacters": "Yra neteisėtų simbolių",
      "maxLength": "Leidžiama daugiausia {max} simbolių",
      "minLength": "Reikia mažiausiai {min} simbolių",
      "notSameAsEmail": "Per daug panašu į el. pašto adresą",
      "onlyValidCharactersAllowed": "Leidžiamos tik raidės, skaičiai ir tarpai.",
      "required": "Privalomas laukas",
      "sameAsPassword": "Slaptažodžiai nesutampa",
      "tcAccepted": "Patvirtinkite mūsų taisykles ir sąlygas.",
      "validEmail": "Neteisingas el. pašto adresas.",
      "validOTP": "Įveskite patvirtinimo kodą."
    }
  }
}
